import { ComputerDesktopIcon, MoonIcon, SunIcon } from '@heroicons/react/24/outline';
import { cn } from '../cn.js';
import { useTheme, type ThemePreference } from '../theme.js';

const OPTIONS: { value: ThemePreference; label: string; Icon: typeof MoonIcon }[] = [
  { value: 'dark', label: 'Dark', Icon: MoonIcon },
  { value: 'light', label: 'Light', Icon: SunIcon },
  { value: 'system', label: 'System', Icon: ComputerDesktopIcon },
];

/**
 * Segmented three-way theme control.
 *
 * Uses aria-pressed on grouped buttons rather than a radiogroup, matching the
 * reference: each button is independently operable and the pressed state is
 * what assistive technology announces.
 */
export function ThemeToggle() {
  const { preference, setPreference } = useTheme();

  return (
    <div
      role="group"
      aria-label="Colour theme"
      className="inline-flex rounded-lg border border-line-strong overflow-hidden"
    >
      {OPTIONS.map(({ value, label, Icon }) => {
        const active = preference === value;
        return (
          <button
            key={value}
            type="button"
            aria-pressed={active}
            aria-label={label}
            title={`${label} theme`}
            onClick={() => setPreference(value)}
            className={cn(
              'p-1.5 transition-colors',
              active
                ? 'bg-brand text-on-brand'
                : 'bg-surface text-muted hover:bg-raised hover:text-body',
            )}
          >
            <Icon className="w-4 h-4" aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
}
